var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseProductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#AA8208"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.25C19.5 15.5596 18.9404 15 18.25 15C17.5596 15 17 15.5596 17 16.25V28.25C17 28.9404 17.5596 29.5 18.25 29.5C18.9404 29.5 19.5 28.9404 19.5 28.25V16.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.25C27 15.5596 26.4404 15 25.75 15C25.0596 15 24.5 15.5596 24.5 16.25V28.25C24.5 28.9404 25.0596 29.5 25.75 29.5C26.4404 29.5 27 28.9404 27 28.25V16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseProductionIcon);
export default __webpack_public_path__ + "static/media/pauseProductionIcon.27d5b74461775cfd4ee6b670fee97022.svg";
export { ForwardRef as ReactComponent };